import * as React from 'react'

function SvgAlarm(props, svgRef) {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path d="M3.75 0A3.75 3.75 0 000 3.75c.003.711.21 1.406.598 2.002l5.699-4.749A3.736 3.736 0 003.75 0zm12.5 0c-.945 0-1.855.358-2.546 1.002l5.699 4.75c.387-.597.594-1.291.597-2.002A3.75 3.75 0 0016.25 0zM10 2.5a8.75 8.75 0 00-8.75 8.75A8.7 8.7 0 003 16.484L1.433 18.05a.624.624 0 000 .884l.884.884a.625.625 0 00.884 0l1.565-1.567a8.704 8.704 0 0010.468 0l1.567 1.566a.625.625 0 00.883 0l.884-.884a.624.624 0 000-.884l-1.566-1.565a8.699 8.699 0 001.748-5.234A8.75 8.75 0 0010 2.5zm3.23 6.21l-3.78 4.727h3.05a.624.624 0 01.625.626v.624a.624.624 0 01-.625.626h-5a.937.937 0 01-.732-1.524l3.779-4.726H7.5a.625.625 0 01-.625-.626v-.624a.625.625 0 01.625-.625h5a.938.938 0 01.732 1.523h-.002z" />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgAlarm)
export default ForwardRef
